import { attribute, create, clickable, collection, text, visitable } from 'ember-cli-page-object';
export default create({
  visit: visitable('/public/:registry'),
  photo: attribute('href', '.avatar'),
  bio: text('.bio'),
  boxes: collection('[data-test-boxes] tbody tr', {
    name: text('td:eq(0)'),
    latestVersion: text('td:eq(1)'),
    downloads: text('td:eq(2)'),
    latestRelease: text('td:eq(3)'),
    providers: collection('td:eq(4) .hds-badge'),
    visit: clickable('td:eq(0) a')
  })
});